export enum ETicketReceiptFormField {
  LAST_NAME = 'lastName',
  RESERVATION_NUMBER = 'reservationNumber',
}
